import React, {PureComponent} from 'react'
import {uniqBy,get} from 'lodash'
import {NotificationManager} from 'modules/Common/components/Notification'
import I18n from 'I18n'
import {Link} from 'react-router-dom'
import styles from './EditAM.module.scss'
import 'react-table/react-table.css'

import {adminURL} from 'modules/Common/constants'
import errorCodeHandle from 'modules/Common/utils/errorCodeHandle'




const I18nLocal = I18n.admin

export class EditAM extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      accountManager: null,
      password: ''
    }
  }

  componentDidMount() {
    const {match, roleList, getRolesList} = this.props
    if (match && match.params.id) {
      const id = match.params.id
      this.props.getAccountManagers(1, [id]).then(() => {
        const accountManager = this.props.accountManagers.records[id]
        this.setState({
          accountManager: accountManager
        })
        const companyId = accountManager ? accountManager.companyId : ''
        this.props.getCompanies(1, [companyId])
      })
    }
    if (!roleList || !roleList.length) {
      getRolesList('ADMINISTRATIVE')
    }
  }

  hanldeChange = (value, key) => {
    let accountManager = {...this.state.accountManager}
    switch (key) {
      case 'firstName':
      case 'lastName':
      case 'email':
      case 'mobilePhoneNumber':
        accountManager.persona[key] = value
        break
      case 'companyId':
        accountManager[key] = value
        break
      default:
    }
    this.setState({accountManager})
  }

  handleChangePassword = (value) => {
    this.setState({password: value})
  }

  handleSaveBtnClicked = () => {
    const accountManager = this.state.accountManager
    if (accountManager) {
      
      const detail = {
        user: {
          ...accountManager
        }
      }

      if (!detail.user.platformRoles) {
        detail.user.platformRoles = {
          roleAssignments: [],
          inheritanceStoppers: {}
        }
      }

      detail.user.biography = detail.user.persona.biography
      delete detail.user.creationTimestamp
      delete detail.user.lastUpdateTimestamp
      delete detail.user.persona.biography
      if (this.state.password) {
        detail.password = this.state.password
      }
      this.props.addOrUpdateAM(detail).then(() => {
        if (!this.props.error) {
          NotificationManager.success(I18nLocal.changesSaved)
          this.props.history.push(adminURL.accountManagers.index)
        } else {
          NotificationManager.error(errorCodeHandle(this.props.error.code, this.props.error.message))
        }
      })
    }
  }

  checkIsNotHaveEmptyField = () => {
    const accountManager = this.state.accountManager
    return (
      accountManager &&
      accountManager.persona.firstName &&
      accountManager.persona.lastName &&
      accountManager.persona.email &&
      accountManager.persona.mobilePhoneNumber &&
      accountManager.companyId
    )
  }

  calculateDataToRender = () => {
    const listSuggestions = this.props.companiesSuggestion.map(item => {
      return {value: item.id, label: item.fullName}
    })
    const accountManager = this.state.accountManager
    const companies = this.props.companies
    const companyId = accountManager ? accountManager.companyId : ''
    let listSuggestionsWithFilledCompany =
      accountManager && accountManager.companyId
        ? [
          ...listSuggestions,
          {
            value: companyId,
            label: companies.records[companyId] ? companies.records[companyId].fullName : ''
          }
        ]
        : listSuggestions
    listSuggestionsWithFilledCompany = uniqBy(listSuggestionsWithFilledCompany, 'value')
    return listSuggestionsWithFilledCompany
  }

  getCompany = () => {
    const companies = this.props.companies
    const accountManager = this.state.accountManager
    const companyId = accountManager ? accountManager.companyId : ''
    return companies.records[companyId]
  }

  getRoleDetail = () => {
    const amRoleId = get(this.state.accountManager, 'platformRoles.roleAssignments[0].roleId')
    return amRoleId ? (this.props.roleList || []).find(v => v.id === amRoleId) : null
  }

  render() {
    const accountManager = this.state.accountManager
    const checkIsNotHaveEmptyField = this.checkIsNotHaveEmptyField()
    const company = this.getCompany()
    const roleDetail = this.getRoleDetail()

    if (accountManager) {
      return (
        <div className={styles.container}>
          <div className={styles.header}>
            <span>{`${I18nLocal.editAm} - ${accountManager.name || ''}`}</span>
          </div>
          <div className={styles.form}>
            <div className={styles.row}>
              <div className={styles.input}>
                <span className={styles['field-title']}>{I18nLocal.firstName}</span>
                <input
                  className={styles['field-input']}
                  type='text'
                  placeholder={I18nLocal.firstName}
                  value={accountManager.persona.firstName}
                  onChange={e => {
                    this.hanldeChange(e.target.value, 'firstName')
                  }}
                />
              </div>
              <div className={styles.input}>
                <span className={styles['field-title']}>{I18nLocal.lastName}</span>
                <input
                  className={styles['field-input']}
                  type='text'
                  placeholder={I18nLocal.lastName}
                  value={accountManager.persona.lastName}
                  onChange={e => {
                    this.hanldeChange(e.target.value, 'lastName')
                  }}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.input}>
                <span className={styles['field-title']}>{I18nLocal.email}</span>
                <input
                  className={styles['field-input']}
                  type='text'
                  placeholder={I18nLocal.email}
                  value={accountManager.persona.email}
                  onChange={e => {
                    this.hanldeChange(e.target.value, 'email')
                  }}
                />
              </div>
              <div className={styles.input}>
                <span className={styles['field-title']}>{I18nLocal.phoneNumber}</span>
                <input
                  className={styles['field-input']}
                  type='text'
                  placeholder={I18nLocal.phoneNumber}
                  value={accountManager.persona.mobilePhoneNumber}
                  onChange={e => {
                    e.target.value = e.target.value.replace(/\D/g,'')
                    this.hanldeChange(e.target.value, 'mobilePhoneNumber')
                  }}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.input}>
                <span className={styles['field-title']}>{I18nLocal.company}</span>
                <span className={styles['field-title']}>{company ? company.fullName : ''}</span>
              </div>
              <div className={styles.input}>
                <span className={styles['field-title']}>{I18nLocal.newPassword}</span>
                <input
                  className={styles['field-input']}
                  type='text'
                  placeholder={I18nLocal.newPassword}
                  value={this.state.password}
                  onChange={e => {
                    this.handleChangePassword(e.target.value)
                  }}
                />
              </div>
            </div>

            <div className={styles.row}>
              <div className={styles.input}>
                <span className={styles['field-title']}>{I18nLocal.role}</span>
                <span className={styles['field-title']}>{roleDetail ? roleDetail.name : ''}</span>
              </div>
            </div>
          </div>
          <hr />
          <div className={styles.buttons}>
            <Link to={adminURL.accountManagers.index} className={`${styles.button} ${styles.red}`}>
              {I18nLocal.cancel}
            </Link>
            <div
              className={`${styles.button} ${!checkIsNotHaveEmptyField ? styles.inactive : ''}`}
              onClick={() => {
                checkIsNotHaveEmptyField && this.handleSaveBtnClicked()
              }}>
              {I18nLocal.save}
            </div>
          </div>
          <hr />
        </div>
      )
    }
  }
}

export default EditAM
